<template>
    <div>
        <div v-if="isBraintree">
            <div ref="braintreeDropinContainer"></div>

            <div
                v-if="braintreeDropinLoading"
                class="flex items-center justify-center"
            >
                <font-awesome-icon icon="spinner" size="3x" spin />
            </div>

            <btn
                v-else
                class="bg-green text-white mx-auto mt-6 px-6"
                ref="dropinButton"
                :disabled="dropinSaveDisabled"
                >{{ $config("ENVIAR") }}</btn
            >
        </div>

        <div v-else-if="!isValidGateway">
            <router-link
                :to="{ name: 'contact' }"
                class="font-secondary text-xl text-blue"
                >{{ $config("CONTACT_SUPPORT") }}</router-link
            >
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import api from "../api";
import Btn from "../components/Btn";

const dropin = require("braintree-web-drop-in");

export default {
    name: "payment-methods-preference",

    components: { Btn },

    data() {
        return {
            braintreeDropinLoading: true,
            dropinSaveDisabled: true
        };
    },

    created() {
        if (this.isValidGateway && !this.isBraintree) {
            window.open(this.externalManagementLink, "_blank");
            this.$router.push({ name: "preferences" });
        }
    },

    async mounted() {
        if (this.isBraintree) {
            const braintreeToken = await api.braintreeToken();

            this.braintreeDropinLoading = false;

            dropin
                .create({
                    authorization: braintreeToken,
                    container: this.$refs.braintreeDropinContainer,
                    locale: this.lang,
                    vaultManager: true,
                    card: {
                        cardholderName: {
                            required: true
                        }
                    },
                    paypal: {
                        flow: "vault"
                    }
                })
                .then(dropinInstance => {
                    this.$refs.dropinButton.$el.addEventListener(
                        "click",
                        () => {
                            dropinInstance.requestPaymentMethod(
                                (requestPaymentMethodErr, payload) => {
                                    console.log(payload);
                                    // Submit payload.nonce to your server
                                }
                            );
                        }
                    );

                    if (dropinInstance.isPaymentMethodRequestable()) {
                        this.dropinSaveDisabled = false;
                    }

                    dropinInstance.on("paymentMethodRequestable", () => {
                        this.dropinSaveDisabled = false;
                    });

                    dropinInstance.on("noPaymentMethodRequestable", () => {
                        this.dropinSaveDisabled = true;
                    });
                });
        }
    },

    computed: {
        ...mapState(["lang", "authenticatedUser"]),

        gateway() {
            return this.authenticatedUser.gateway;
        },

        isValidGateway() {
            return ["apple", "google", "roku", "braintree"].includes(
                this.gateway
            );
        },

        isBraintree() {
            return this.gateway == "braintree";
        },

        externalManagementLink() {
            return {
                apple: "https://apple.co/2Th4vqI",
                google: "https://myaccount.google.com/subscriptions",
                roku: "https://my.roku.com/account/subscriptions"
            }[this.gateway];
        }
    }
};
</script>
